module.exports = __webpack_public_path__ + "img/14.00f8fe04.png";